export const GET_NZ_VARIABLES_SUCCESS = 'GET_NZ_VARIABLES_SUCCESS'
export const RESET_VARIABLES_SUCCESS = 'RESET_VARIABLES_SUCCESS'
